import { Container } from "react-bootstrap"

const AutomationCaseStudy = () => {
    return (
        <section className="case-study-content-block py-5">
            <Container>
                <div>
                    <h2 className="text-primary ft-wt-700 mb-4">Electronic Medical Records Application</h2>
                    <p>Healthcare organizations work hard to provide the best in patient care while operating efficiently and cost-effectively. We've designed a patient record management application to provide innovative features including clinical data sharing, electronic referrals, mobile connectivity, and much more. We have also developed a patient portal that patients can use to schedule appointments, see health documents, and pay medical bills. Physicians can send and receive secure patient messages in real-time, strengthening the doctor-patient relationship. In this system we integrated Stripe for Payments infrastructure and Twilio API gateway for SMS feature and Voice calls.</p>

                    <p>This enterprise system contains an umbrella of applications including Web Applications, Mobile Applications, multiple REST APIs and Schedulers which are connected to each other. &nbsp;Testing the entire system is a big challenge whenever we add new features to the application or changes to the system. One more challenge is time consuming if we depend only on manual testing and it may not be accurate if we miss even a single test case from being executed. We identified a few areas to automate testing and implemented. This automation helped us in reducing the testing time, faster releases with improved quality of applications. Security is also at most concern in this application.</p>

                    <p>We listed below a few areas for the automation of testing and frameworks which we used.</p>

                    <ul>
                        <li>Web UI testing</li>
                        <li>Hybrid Framework using Java, Selenium and TestNG</li>
                        <li>BDD framework with cucumber</li>


                        <li>Mobile Application UI testing</li>
                        <li>Hybrid Framework using Java, Appium and TestNG</li>


                        <li>API testing</li>
                        <li>SoapUI Pro, SoapUI and Groovy Scripting</li>


                        <li>Load testing</li>
                        <li>JMeter</li>


                        <li>Security testing</li>
                        <li>Burp Suite</li>
                    </ul>


                </div>
            </Container>

        </section>
    )
}

export default AutomationCaseStudy